<template>
  <div class="ep_index">
    <Menu />
    <div class="ep_bx">
      <div class="bnr">
        <p class="title">企业远控<br />要有企业级安全服务</p>
        <p class="sub_title">
          ToDesk 企业版：<br />每一个需要远程办公的企业都可以放心使用
        </p>
        <img src="@/assets/epindex/bnr.png" alt="" class="pic" />
        <div class="btns">
          <a
            class="link_btn btn1 epBtn1"
            href="https://console.todesk.com/#/register"
            >前往注册</a
          >
          <a
            class="link_btn btn2 epBtn2"
            href="https://enterprise.todesk.com/contact"
            >联系我们</a
          >
        </div>
      </div>
      <div class="bigDataPoint">
        <div class="dataPoint">
          <div class="point1" @click="goLink('/solutions/design')">
            <img src="@/assets/epindex/dataPoint1.png" alt="" />
            <div class="contain">
              <div class="title1">高性能远程安全办公</div>
              <div class="title2">稳定、精准、真高清远程设计</div>
            </div>
          </div>
          <div class="point1" @click="goLink('/solutions/localization')">
            <img src="@/assets/epindex/dataPoint2.png" alt="" />
            <div class="contain">
              <div class="title1">信创解决方案</div>
              <div class="title2">帮助客户快速推进信创建设</div>
            </div>
          </div>
          <div class="point1 last" @click="goLink('/solutions/remoteSupport')">
            <img src="@/assets/epindex/dataPoint3.png" alt="" />
            <div class="contain">
              <div class="title1">技术支持</div>
              <div class="title2">向客户提供使用指导、问题排查维修</div>
            </div>
          </div>
        </div>
      </div>

      <ScrollUsers />
      <div class="pdn ftr1">
        <h2 class="title">
          <span class="line"></span>
          <span class="t">更流畅</span>
          <span class="line"></span>
        </h2>
        <h3 class="sub_title">企业版专享高速线路</h3>
        <video
          preload="auto"
          playsinline
          playsinlinex5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x5-playsinline="true"
          x-webkit-airplay="allow"
          x5-video-orientation="landscape|portrait"
          style="object-fit: fill"
          webkit-playsinline="true"
          x5-video-player-type="h5-page"
          autoplay
          muted
          loop
          class="vdo"
          src="https://todeskcdnspeed.todesk.com/202207201744445e439736c891e4.mp4"
        ></video>
        <p class="desc_title">建模型，写代码，改文档<br />样样都流畅</p>
        <div class="desc_bx">
          <p class="desc_item">
            <img src="@/assets/epindex/check@2x.png" alt="" /><span
              >持久稳定连接，不卡顿、不掉线</span
            >
          </p>
          <p class="desc_item">
            <img src="@/assets/epindex/check@2x.png" alt="" /><span
              >字体清晰强化，写文档、码代码更轻松</span
            >
          </p>
          <p class="desc_item">
            <img src="@/assets/epindex/check@2x.png" alt="" /><span
              >高清高帧，精准响应，满足三维设计与图形操作</span
            >
          </p>
        </div>
        <a href="https://console.todesk.com/#/register" class="btn epBtn2"
          >立即试用</a
        >
      </div>
      <div class="pdn ftr2">
        <h2 class="title">
          <span class="line"></span>
          <span class="t">更安全</span>
          <span class="line"></span>
        </h2>
        <h3 class="sub_title">23项措施 全方位安全保障</h3>
        <div class="desc_bx">
          <div
            class="desc_item"
            :class="{ active: ftr2_active == 0 }"
            @click="ftr2_active = 0"
          >
            日志记录
          </div>
          <div
            class="desc_item"
            :class="{ active: ftr2_active == 1 }"
            @click="ftr2_active = 1"
          >
            操作录屏
          </div>
          <div
            class="desc_item"
            :class="{ active: ftr2_active == 2 }"
            @click="ftr2_active = 2"
          >
            可控文件传输
          </div>
        </div>
        <img
          v-touch:swipe.left="ftr2Left"
          v-touch:swipe.right="ftr2Right"
          class="desc_pic"
          :src="require(`@/assets/epindex/sf${ftr2_active + 1}@2x.png`)"
          alt=""
        />
        <a href="https://console.todesk.com/#/register" class="btn epBtn1"
          >立即试用</a
        >
      </div>
      <div class="safe_info">
        <div class="safe_item safe_item0">
          <div class="item" v-for="(item, index) in sf_info1" :key="index">
            <img
              class="icon"
              :src="require(`@/assets/epindex/sf_icon${index + 1}@2x.png`)"
              :alt="item"
            />
            <p class="title">{{ item }}</p>
          </div>
        </div>
        <div class="safe_item safe_item1">
          <div
            class="item"
            v-for="(item, index) in sf_info2"
            :key="index + sf_info2.length"
          >
            <img
              class="icon"
              :src="require(`@/assets/epindex/sf_icon${index + 5}@2x.png`)"
              :alt="item"
            />
            <p class="title">{{ item }}</p>
          </div>
        </div>
      </div>
      <div class="pdn ftr3">
        <h2 class="title">
          <span class="line"></span>
          <span class="t">更高效</span>
          <span class="line"></span>
        </h2>
        <h3 class="sub_title">轻松部署 统一管理</h3>
        <div class="desc_bx">
          <div
            class="desc_item"
            :class="{ active: ftr3_active == 0 }"
            @click="ftr3_active = 0"
          >
            快速部署
          </div>
          <div
            class="desc_item"
            :class="{ active: ftr3_active == 1 }"
            @click="ftr3_active = 1"
          >
            统一配置
          </div>
          <div
            class="desc_item"
            :class="{ active: ftr3_active == 2 }"
            @click="ftr3_active = 2"
          >
            分组管理
          </div>
        </div>
        <div v-touch:swipe.left="ftr3Left" v-touch:swipe.right="ftr3Right">
          <div class="desc_vp" v-show="ftr3_active == 0">
            <video
              preload="auto"
              playsinline
              playsinlinex5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-playsinline="true"
              x-webkit-airplay="allow"
              x5-video-orientation="landscape|portrait"
              style="object-fit: fill"
              webkit-playsinline="true"
              x5-video-player-type="h5-page"
              autoplay
              muted
              loop
              src="https://todeskcdnspeed.todesk.com/202207201223295e434f68dd7814.mp4"
            ></video>
          </div>
          <div class="desc_vp" v-show="ftr3_active == 1">
            <video
              preload="auto"
              playsinline
              playsinlinex5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-playsinline="true"
              x-webkit-airplay="allow"
              x5-video-orientation="landscape|portrait"
              style="object-fit: fill"
              webkit-playsinline="true"
              x5-video-player-type="h5-page"
              autoplay
              muted
              loop
              src="https://todeskcdnspeed.todesk.com/202207191835295e4260b12681ac.mp4"
            ></video>
          </div>
          <div class="desc_vp" v-show="ftr3_active == 2">
            <img src="@/assets/epindex/enterprise5-2-1@2x.png" alt="" />
          </div>
          <div class="info_bx">
            <p class="info_item">
              · 命令行静默部署，一条命令完成安装、绑定两步操作
            </p>
            <p class="info_item">
              · 可对接公司AD域，批量导入成员账号和下发安装包
            </p>
            <p class="info_item">· 可对接飞书账号，同步用户目录和登录验证</p>
          </div>
        </div>
        <a href="https://console.todesk.com/#/register" class="epBtn1 btn"
          >立即试用</a
        >
      </div>
      <div class="pdn tec_bx">
        <p class="bx_sub_title">掌握核心技术</p>
        <div class="cont">
          <router-link
            :to="`/news/${item.link_id}`"
            class="item"
            v-for="(item, index) in tec_list"
            :key="index"
          >
            <img
              class="item_icon"
              :src="require(`@/assets/epindex/${item.icon}`)"
              alt=""
            />
            <p class="title">{{ item.title }}</p>
            <div class="desc_info">
              <p
                class="desc"
                v-for="(pitem, pindex) in item.desc"
                :key="pindex"
              >
                {{ pitem }}
              </p>
            </div>
            <div class="link">
              <span class="t1">点击探索</span
              ><img
                :src="require(`@/assets/epindex/toright1@2x.png`)"
                alt=""
                class="ticon"
              />
            </div>
          </router-link>
        </div>
      </div>
      <div class="pdn usr_bx">
        <h2 class="title">ToDesk正在成为各行各业<br />高效实用的远控软件</h2>
        <div class="cont">
          <div class="item" v-for="(item, index) in usr_list" :key="index">
            <img :src="require(`@/assets/users/${item}`)" alt="" />
          </div>
        </div>
      </div>
      <Certificate />
    </div>
    <div class="contact">
      <h2 class="title">
        <span class="t2">企业级安全</span>
        <span class="t1">的远程办公</span>
      </h2>
      <div class="btns">
        <a
          href="https://console.todesk.com/#/register"
          class="epBtn1 ctcBtn ctcBtn1"
          >前往注册</a
        >
        <a
          href="https://enterprise.todesk.com/contact"
          class="epBtn2 ctcBtn ctcBtn2"
          >联系我们</a
        >
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import ScrollUsers from "@/components/ScrollUsers";
import Certificate from "@/components/Common/Certificate";
import { videoReady } from "../utils/util";
export default {
  components: {
    Menu,
    Footer,
    ScrollUsers,
    Certificate,
  },
  data() {
    return {
      ftr2_active: 0,
      sf_info1: ["屏幕水印", "隐私屏", "系统锁定", "双因认证"],
      sf_info2: ["设备-用户绑定", "禁用设备码", "端到端加密", "可控剪贴板"],

      ftr3_active: 0,

      active_tec: 0,
      tec_list: [
        {
          link_id: 420,
          icon: "tec_icon3@2x.png",
          icon_active: "tec_icon_active3@2x.png",
          title: "业内首发RTC",
          desc: ["重构优化底层框架，", "定义高性能远程技术新标准"],
          bkg: "tec_bkg3@2x.png",
        },
        {
          link_id: 413,
          icon: "tec_icon2@2x.png",
          icon_active: "tec_icon_active2@2x.png",
          title: "自带SD-WAN网络",
          desc: ["全网质量感知+实时线路优化，", "为您的数据传输智能导航"],
          bkg: "tec_bkg2@2x.png",
        },
        {
          link_id: 410,
          icon: "tec_icon1@2x.png",
          icon_active: "tec_icon_active1@2x.png",
          title: "高效视频编解码",
          desc: ["算法硬件两手抓，画质更高，", "速度更快，带宽更省"],
          bkg: "tec_bkg1@2x.png",
        },
      ],
      usr_list: [
        "walmart@2x.png",
        "bodor@2x.png",
        "bohai@2x.png",
        "naked@2x.png",
        "cir@2x.png",
        "vic2.png",
        "teren@2x.png",
        "yuncong@2x.png",
        "guoda@2x.png",
        "chuanmeidaxue@2x.png",
        "ennead@2x.png",
        "zenlayer@2x.png",
      ],
    };
  },
  mounted() {
    videoReady();
  },
  methods: {
    ftr2Right() {
      if (this.ftr2_active == 0) {
        this.ftr2_active = 2;
      } else {
        this.ftr2_active--;
      }
    },
    ftr2Left() {
      if (this.ftr2_active == 2) {
        this.ftr2_active = 0;
      } else {
        this.ftr2_active++;
      }
    },
    ftr3Right() {
      if (this.ftr3_active == 0) {
        this.ftr3_active = 2;
      } else {
        this.ftr3_active--;
      }
    },
    ftr3Left() {
      if (this.ftr3_active == 2) {
        this.ftr3_active = 0;
      } else {
        this.ftr3_active++;
      }
    },
    goLink(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>
<style lang="less" scoped>
.ep_index {
  .bnr {
    padding-top: 48px;
    padding-bottom: 60px;
    text-align: center;
    background: rgba(232, 244, 255, 0.6);
    .title {
      font-size: 34px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      line-height: 48px;
    }
    .sub_title {
      margin-top: 8px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222429;
      line-height: 22px;
    }
    .pic {
      margin-top: -10px;
      width: 307px;
      height: auto;
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 6px;
      .btn1 {
        height: 54px;
        width: 156px;
        line-height: 54px;
      }
      .btn2 {
        height: 54px;
        width: 156px;
        line-height: 52px;
      }
    }
    .link_btn {
      margin-left: 8px;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ftr1 {
    background: #f6f6f8;
    text-align: center;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      .line {
        width: 20px;
        height: 2px;
        background: #216ed8;
        border-radius: 4px;
      }
      .t {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #216ed8;
        margin-left: 15px;
        margin-right: 15px;
      }
    }
    .sub_title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1e232a;
      margin-top: 8px;
    }
    .vdo {
      width: 300px;
    }
    .desc_title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      line-height: 28px;
      margin-top: 24px;
    }
    .desc_bx {
      margin-top: 12px;
    }
    .desc_item {
      display: flex;
      align-items: center;
      padding-left: 29px;
      margin-bottom: 6px;
      img {
        width: 16px;
        height: 16px;
      }
      span {
        margin-left: 6px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 36, 41, 1);
      }
    }
    .btn {
      margin: auto;
      margin-top: 32px;
      width: 311px;
      height: 48px;
      line-height: 46px;
      display: block;
      font-size: 18px;
    }
  }
  .ftr2 {
    background: #fff;
    text-align: center;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      .line {
        width: 20px;
        height: 2px;
        background: #216ed8;
        border-radius: 4px;
      }
      .t {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #216ed8;
        margin-left: 15px;
        margin-right: 15px;
      }
    }
    .sub_title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1e232a;
      margin-top: 8px;
    }
    .desc_title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      line-height: 28px;
      margin-top: 24px;
    }
    .desc_bx {
      margin-top: 32px;
      display: flex;
      padding-left: 40px;
      padding-right: 40px;
      justify-content: space-between;
      align-items: center;
    }
    .desc_item {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(30, 35, 42, 0.6);
      padding-bottom: 6px;
      border-bottom: 2px solid transparent;
      &.active {
        border-color: #0065dd;
        font-weight: 600;
        color: #0065dd;
      }
    }
    .desc_pic {
      margin-top: 27px;
      width: 330px;
      height: auto;
      touch-action: pan-y;
    }
    .btn {
      margin: auto;
      margin-top: 40px;
      width: 311px;
      height: 48px;
      line-height: 48px;
      display: block;
      font-size: 18px;
    }
  }
  .safe_info {
    padding-top: 16px;
    padding-bottom: 40px;
    background-color: #fff;
    .safe_item {
      padding-left: 20px;
      padding-right: 20px;
      display: flex;
      justify-content: space-between;
      .item {
        text-align: center;
        flex: 0 0 25%;
        .icon {
          width: 36px;
          height: 36px;
        }
        .title {
          margin-top: 10px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222429;
        }
      }
    }
    .safe_item0 {
      margin-bottom: 24px;
    }
  }
  .ftr3 {
    background: #29303a;
    text-align: center;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      .line {
        width: 20px;
        height: 2px;
        background: #3d94ff;
        border-radius: 4px;
      }
      .t {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3d94ff;
        margin-left: 15px;
        margin-right: 15px;
      }
    }
    .sub_title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fff;
      margin-top: 8px;
    }
    .desc_title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      line-height: 28px;
      margin-top: 24px;
    }
    .desc_bx {
      margin-top: 32px;
      display: flex;
      padding-left: 40px;
      padding-right: 40px;
      justify-content: space-between;
      align-items: center;
    }
    .desc_item {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      padding-bottom: 6px;
      border-bottom: 2px solid transparent;
      &.active {
        border-color: #fff;
        color: #fff;
        font-weight: 600;
      }
    }
    .desc_vp {
      margin-top: 30px;
      video,
      img {
        width: 330px;
        height: auto;
      }
    }
    .info_bx {
      padding-left: 20px;
      text-align: left;
      margin-top: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
    }
    .btn {
      margin: auto;
      margin-top: 40px;
      width: 311px;
      height: 48px;
      line-height: 48px;
      font-size: 18px;
      display: block;
      background: #2078e1;
    }
  }
  .tec_bx {
    background: #fff;
    .bx_sub_title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1e232a;
      text-align: center;
    }
    .cont {
      margin-top: 24px;
      .item {
        width: 327px;
        background: #f9f9f9;
        height: 248px;
        padding-top: 32px;
        box-sizing: border-box;
        position: relative;
        text-align: center;
        margin: auto;
        text-align: center;
        display: block;
        .item_icon {
          width: 48px;
          height: 48px;
        }
        .title {
          margin-top: 24px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222429;
        }
        .desc_info {
          margin-top: 8px;
          height: 48px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #383a3d;
        }
        .link {
          margin-top: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          .t1 {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #216ed8;
          }
          .ticon {
            margin-left: 4px;
            width: 16px;
            height: 16px;
          }
        }
        .bkg {
          display: none;
        }
      }
      .item:nth-child(2) {
        background: #f2f2f2;
      }
    }
  }
  .usr_bx {
    background: #ffffff;
    .title {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1e232a;
      margin-bottom: 18px;
      text-align: center;
    }
    .cont {
      text-align: center;
      .item {
        display: inline-block;
        width: 110px;
        height: 35px;
        background: #ffffff;
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 5px;
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 6px;
        line-height: 35px;
        img {
          margin-top: 5px;
          text-align: center;
          height: 25px;
          width: auto;
        }
      }
    }
  }
  .contact {
    width: 100%;
    height: 200px;
    background: #ffffff;
    background-image: url("~@/assets/epindex/bkg.png");
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 50px;
    box-sizing: border-box;
    .title {
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      .t1 {
        color: #222429;
      }
      .t2 {
        color: #0065dd;
      }
    }
    .btns {
      margin-top: 24px;
      display: flex;
      justify-content: center;
    }
  }
}
.bigDataPoint {
  height: 238px;
  position: relative;
}
.dataPoint {
  width: 343px;
  margin: auto;
  position: absolute;
  top: -36px;
  left: 16px;
  .point1 {
    width: 100%;
    padding: 12px 12px;
    display: flex;
    align-items: center;
    border: 1px solid #0000000d;
    box-shadow: 0px 10px 10px 0px #162d4a1c;
    box-sizing: border-box;
    background: linear-gradient(to bottom, #fff, #f3f9ff);
    border-radius: 4px;
    margin-bottom: 15px;
    &.last {
      margin: 0;
    }
    img {
      width: 48px;
      height: 48px;
      margin-right: 8px;
    }
    .contain {
      .title1 {
        color: #222429;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 2px;
      }
      .title2 {
        color: #616369;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
</style>
